import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firebase-firestore';


const firebaseConfig = {
  apiKey: FB_API_KEY,
  authDomain: "test-auth-ea018.firebaseapp.com",
  databaseURL: "https://test-auth-ea018.firebaseio.com",
  projectId: "test-auth-ea018",
  storageBucket: "test-auth-ea018.appspot.com",
  messagingSenderId: "286317147462",
  appId: "1:286317147462:web:428be6d445db058bc1e147"
}

firebase.initializeApp(firebaseConfig);

export const auth = firebase.auth();
